import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { IBiocatchContextModel } from '../../models/biocatch-context.model';
import { CryptDataService } from '../security/crypt-data.service';
import { RequestService } from '../request/request-onboarding.service';

@Injectable({
  providedIn: 'root',
})
export class ParametersService {

  private applicationParameters: any;
  private businessRules: any;
  private settings: any;
  private biocatchContextParams: IBiocatchContextModel;

  constructor(
    private _http: HttpClient, private cryptDataService: CryptDataService) { }

  async loadApplicationParameters() {
    const url = './assets/resources/application_parameters.json';

    await this._http.get(url).toPromise().then(async response => {
      this.applicationParameters = await this.cryptDataService.descrypterParameters(response['data'].parameters);
    });
  }

  async loadBusinessRules() {
    const url = './assets/resources/business_rules.json';
    await this._http.get(url).toPromise().then(response => {
      this.businessRules = response['data'].business_rules;
    });
  }

  async loadApplicationSettings(response) {
    this.settings = response.data;
  }

  /**
   * Llena la propiedad con info de archivo json los parametros de contextos de biocatch.
   *
   * * fill property with json file's biocatch context params. *
   *
   */
  async loadBiocatchContext() {
    const url = './assets/resources/biocatch_context.json';

    await this._http.get(url)
      .pipe(map<any, IBiocatchContextModel>(data => data))
      .toPromise().then(res => this.biocatchContextParams = res);
  }

  async importContext() {
    const url = './assets/resources/import-context.json';

    await this._http.get(url)
      .pipe(map<any, IBiocatchContextModel>(data => data))
      .toPromise().then(res => this.biocatchContextParams = res);
  }

  getParameter(parameterName: string): any {
    return this.applicationParameters[parameterName];
  }

  getBusinessRule(ruleName: string): any {
    return this.businessRules[ruleName];
  }

  getSetting(settingName: string): any {
    return this.settings[settingName];
  }

  /**
   * Expone los parametros de contextos de biocatch.
   *
   * * Exposed Biocatch context params. *
   *
   * @returns Parametros de contextos de biocatch tipados.
   *
   * * Biocatch context params typed *
   */
  getBiocatchContextParams(): IBiocatchContextModel {
    return this.biocatchContextParams;
  }
}
